import { ArrowRight } from 'lucide-react';
import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ToastProvider } from '@/components/ui';
import { DutyExample } from '../duty/DutyView';
import { Code, Section } from './Section';
export function DutyPatternsSection() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash !== '#duty-patterns') return;
    const section = document.getElementById('duty-patterns'),
      main = section?.closest('main'),
      root = main?.parentElement;
    if (!section || !main || !root) return;
    let active = true;
    const align = () =>
      requestAnimationFrame(() => {
        if (!active || location.hash !== '#duty-patterns') return;
        const header = root.querySelector('header')?.getBoundingClientRect().height ?? 0;
        root.scrollTo({
          top:
            root.scrollTop +
            section.getBoundingClientRect().top -
            root.getBoundingClientRect().top -
            header -
            24,
          behavior: 'instant',
        });
      });
    const observer = new ResizeObserver(align);
    const stop = () => {
      active = false;
      observer.disconnect();
      root.removeEventListener('scroll', align);
      for (const e of ['wheel', 'pointerdown', 'keydown']) root.removeEventListener(e, stop, true);
    };
    observer.observe(main);
    root.addEventListener('scroll', align, { passive: true });
    for (const e of ['wheel', 'pointerdown', 'keydown']) root.addEventListener(e, stop, true);
    align();
    void document.fonts.ready.then(align);
    return stop;
  }, [hash]);
  return (
    <Section
      id="duty-patterns"
      title="Сетка дежурств и карточка события"
      lead="Расписания и слои, два деления на день, выбранный часовой пояс и подробности рядом с событием. Примерные данные."
    >
      <div className="overflow-hidden rounded-lg border border-line bg-card">
        <header className="flex flex-wrap items-center gap-4 border-b border-line p-5">
          <div className="min-w-0 flex-1">
            <h3 className="type-heading">Расписания и события</h3>
            <p className="mt-1 text-sm text-fg-muted">
              Общая шкала, сворачиваемые группы и предварительные события. Карточка подходит и другим
              небольшим объектам.
            </p>
          </div>
          <Link
            to="/design/duty"
            className="inline-flex h-9 items-center gap-2 rounded-md border border-line bg-muted px-3 text-xs font-semibold text-fg hover:bg-hover focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
          >
            Открыть образец
            <ArrowRight className="size-4" />
          </Link>
        </header>
        <div className="p-5">
          <ToastProvider>
            <DutyExample />
          </ToastProvider>
        </div>
        <p className="border-t border-line p-4">
          <Code>TimeGrid · Disclosure · Popover · ObjectPreview · TimeInterval · RelativeTime</Code>
        </p>
      </div>
    </Section>
  );
}
